import React from 'react'
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroImgSecond from "../components/HeroImgSecond";
import ResumeFile from "../components/Resume";


const Blogs = () => {
  return (
    <div>
      <Navbar/>
      <HeroImgSecond/>
      <ResumeFile/>
      <Footer />
    </div>
  )
}

export default Blogs
